<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'

    >
      <wc-two-column-table :items='items'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      :disableButtons='!isFormValid'
      width='350'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid'>
        <v-row>
          <v-col cols='6'>
            <v-text-field
              label='Smalls'
              v-model='estimateDetailCopy.smalls'
              :rules='[rules.int]'
            ></v-text-field>
          </v-col>
          <v-col cols='6'>
            <v-text-field
              label='Bigs'
              v-model='estimateDetailCopy.bigs'
              :rules='[rules.int]'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'head-count',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    title: 'Head Count',
    icon: 'mdi-sprinkler',
    iconColor: 'success',
    isFormValid: false,
    showDialog: false,
    estimateDetailCopy: {},
    estimateCopy: {}
  }),
  computed: {
    items () {
      if (this.estimateDetail) {
        return [
          { text: 'Smalls', value: this.estimateDetail.smalls },
          { text: 'Bigs', value: this.estimateDetail.bigs }
        ]
      }
      return []
    }
  },
  methods: {
    openEdit () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.estimateCopy)
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.showDialog = false
    }
  }
}
</script>